import { render } from "./AddValidationQueuePage.vue?vue&type=template&id=3a7d9b36&ts=true"
import script from "./AddValidationQueuePage.vue?vue&type=script&lang=ts"
export * from "./AddValidationQueuePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__